var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1676 8.23695C22.0471 7.97706 21.7967 7.79142 21.5093 7.79142H15.2698L15.5294 7.53152C16.3916 6.64045 16.8644 5.42451 16.7903 4.18072C16.7161 2.93693 16.132 1.79524 15.1492 0.996988C13.3506 -0.451006 10.7732 -0.311778 9.18782 1.3497L1.9655 8.79387C0.76951 9.84274 0 11.3928 0 13.1007C0 16.2566 2.56814 18.8556 5.74818 18.8556H12.1546C12.34 18.8556 12.5255 18.7813 12.6645 18.6421L22.0192 9.02592C22.2139 8.79387 22.2603 8.49685 22.1676 8.23695ZM11.8579 17.4354H5.75744C3.37473 17.4354 1.43705 15.4955 1.43705 13.11C1.43705 10.7245 3.37473 8.78459 5.75744 8.78459C7.29647 8.78459 8.53882 10.0469 8.53882 11.5692C8.53882 13.0914 7.27793 14.3538 5.75744 14.3538C5.08064 14.3538 4.5151 13.7876 4.5151 13.11C4.5151 12.4324 5.08064 11.8662 5.75744 11.8662C5.83161 11.8662 5.87798 11.8662 5.94288 11.8941C6.31373 11.9869 6.71238 11.7548 6.78655 11.3557C6.87927 10.9844 6.6475 10.5853 6.24883 10.511C6.08195 10.4646 5.92434 10.4646 5.73891 10.4646C4.26478 10.4646 3.07805 11.662 3.07805 13.1286C3.07805 14.6044 4.27405 15.7925 5.73891 15.7925C7.04616 15.7925 8.21434 15.1799 8.98385 14.2517L13.8698 9.22085H19.7849L11.8579 17.4354Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetal);
export default __webpack_public_path__ + "static/media/metal.75da0b60f99aaec9d562f77339406192.svg";
export { ForwardRef as ReactComponent };